/**
 * RR Vodka Shopify Theme
 * Mobile nav toggle + sticky header helper
 */
(function () {
  'use strict';

  function initMobileNav() {
    var toggle = document.querySelector('.rr-nav__toggle');
    var mobileNav = document.getElementById('rr-nav-mobile');
    if (!toggle || !mobileNav) return;

    function setOpen(isOpen) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      mobileNav.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('rr-nav-open', isOpen);
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setOpen(!expanded);
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle.click();
      }
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('click', function (e) {
      if (!toggle.contains(e.target) && !mobileNav.contains(e.target)) {
        setOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) {
        setOpen(false);
      }
    });
  }

  function initVariantSelect() {
    var form = document.querySelector('.rr-product-form');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('.rr-product-form__select');
    if (!variantInput || selects.length === 0) return;

    var productJson = document.getElementById('product-json');
    if (!productJson) return;

    try {
      var product = JSON.parse(productJson.textContent);
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var options = [];
          selects.forEach(function (s) {
            options.push(s.value);
          });
          var variant = product.variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return opt === options[i];
            });
          });
          if (variant) {
            variantInput.value = variant.id;
          }
        });
      });
    } catch (err) {
      /* variant sync optional */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMobileNav();
      initVariantSelect();
    });
  } else {
    initMobileNav();
    initVariantSelect();
  }
})();
